<template lang="pug">
  .wrap.static
    form(@submit.prevent="update")
      .main
        .main-inner
          .panel-title
            h2
              img(:src="siteLogoBlue()" :alt="siteName()")
            h3 パスワード再設定
          .panel(v-if="updated")
            p.message
              | パスワードを再設定しました
          .panel(v-else)
            p
              span.panel-label
                | パスワード
              input(type="password" v-model="password", :disabled="locked",
                    @blur="checkInputted")
            p
              span.panel-label
                | パスワード再入力
              input(type="password" v-model="passwordVerification", :disabled="locked",
                    @blur="checkInputted")
            ErrorMessage(:errors="errors" name="system")
            ErrorMessage(:errors="verificationErrors" name="system")
            p.buttons
              input.button-main.button-block(type="submit",
              value="パスワードを再設定する", :disabled="disabled")
          p.panel-note
            router-link(:to="{ name: 'SignIn' }") ログイン画面に戻る
    footer.footer
      p.copyright
        | &copy; {{ copyright() }}
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import ErrorMessage from './parts/ErrorMessage'
  import { HumanErrorMessages } from '../constants'

  export default {
    components: { ErrorMessage },
    async asyncData ({ store }) {
      store.commit('user/preparePasswordUpdate')
    },
    data () {
      return {
        password: '',
        passwordVerification: '',
        verificationRequired: false,
        updated: false,
      }
    },
    computed: {
      ...mapState({
        errors: state => state.user.passwordErrors,
      }),
      ...mapGetters({
        locked: 'common/isGlobalLocked',
      }),
      disabled () {
        return this.locked || !this.password
      },
      same () {
        return this.password === this.passwordVerification
      },
      verificationErrors () {
        if (this.verificationRequired && !this.same) {
          return [{ type: 'system', message: HumanErrorMessages.DIFFERENT_PASSWORDS }]
        }

        return []
      },
    },
    methods: {
      async update () {
        this.$store.commit('common/lockGlobal')
        const {
          password,
          $route: {
            query: {
              reset_password_token: resetPasswordToken,
            },
          },
        } = this
        try {
          await this.$store.dispatch('user/updatePassword', { password, resetPasswordToken })
          this.updated = true
        } finally {
          this.$store.commit('common/unlockGlobal')
        }
      },
      checkInputted () {
        if (!!this.password && !!this.passwordVerification) {
          this.verificationRequired = true
        }
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/ResetPassword.vue